import { AxiosInstance } from 'axios';

export default class FileManagementAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async listFileTypes() {
    return this.client.get('/v2/file-management/file-type/');
  }
}
  